export const COMPLIANCE_STATS_TABS = {
	TEXTS: "Texts",
	EMAILS: "Emails",
};

export const COMPLIANCE_STATS_TABLE_COLUMNS = [
    { id: "view", isSortable: false, label: "View" },
    { id: "group", isSortable: false, label: "Group" },
    { id: "ruleid", isSortable: false, label: "Rule ID" },
    { id: "description", isSortable: false, label: "Description" },
    { id: "yespercentage", isSortable: false, label: "Yes %" },
	{ id: "nopercentage", isSortable: false, label: "No %" },
    { id: "total", isSortable: false, label: "Total" },
	{ id: "yes", isSortable: false, label: "Yes" },
	{ id: "no", isSortable: false, label: "No" },
];

export const COMPLIANCE_STATS_TABLE_COLUMN_KEYS = {
    VIEW: "view",
    GROUP: "group",
    RULE_ID: "ruleid",
    DESCRIPTION: "description",
    YES_PERCENTAGE: "yespercentage",
	NO_PERCENTAGE: "nopercentage",
	TOTAL: "total",
	YES: "yes",
	NO: "no",
};

export const COMPLIANCE_STATS_KEYS = {
	VIEW: "View",
    GROUP: "Group",
    RULE_ID: "RuleID",
    DESCRIPTION: "Description",
    YES_PERCENTAGE: "Yes%",
    NO_PERCENTAGE: "No%",
    TOTAL: "Total",
    YES: "Yes",
	NO: "No",
};

export const COMPLIANCE_STATS_INFO_TABLE_COLUMNS = [
    { id: "conversationid", isSortable: false, label: "Conversation ID" },
    { id: "compliant", isSortable: false, label: "Compliant" },
    { id: "comments", isSortable: false, label: "Comments" },
    { id: "lastconversationdate", isSortable: false, label: "Last Conversation Date" },
    { id: "lastcompliancecheck", isSortable: false, label: "Last Compliance Check" },
];

export const COMPLIANCE_STATS_INFO_TABLE_COLUMN_KEYS = {
    CONVERSATION_ID: "conversationid",
    COMPLIANT: "compliant",
    COMMENTS: "comments",
    LAST_CONVERSATION_DATE: "lastconversationdate",
    LAST_COMPLIANCE_CHECK: "lastcompliancecheck",
};

export const COMPLIANCE_STATS_INFO_KEYS = {
	CONVERSATION_ID: "ConversationID",
    COMPLIANT: "Compliant",
    COMMENTS: "Comments",
    LAST_CONVERSATION_DATE: "LastConversationDate",
    LAST_COMPLIANCE_CHECK: "LastComplianceCheck",
};

export const COMPLIANCE_STATS_MESSAGES = {
    NO_COMPLIANCE_STATS: "No Compliance Stats to Display",
    NO_COMPLIANCE_STAT_RULE: "No Compliance Stats for Selected Rule to Display",
};

export const COMPLIANCE_STATS_ERRORS = {
	FETCH_COMPLIANCE_STATS_ERROR: "Error fetching compliance stats.",
};

export const formatDate = (value) => {
    if (!value) return "";
    const normalized = value.replace("T", " ").replace("Z", "");
    const [datePart, timePart = "00:00:00"] = normalized.split(" ");
    const [year, month, day] = datePart.split("-");
    const [hour = "00", minute = "00"] = timePart.split(":");
    const h24 = Number(hour);
    const h12 = h24 % 12 || 12;
    const amPm = h24 >= 12 ? "PM" : "AM";
    const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ];
    return `${monthNames[Number(month) - 1]} ${day}, ${year}, ${String(
        h12
    ).padStart(2, "0")}:${minute} ${amPm}`;
};

export const formatDateTime = (value) => {
    if (!value) return null;
    if (value instanceof Date && !isNaN(value)) {
        const pad = (n, z = 2) => String(n).padStart(z, "0");
        return (
            value.getFullYear() + "-" +
            pad(value.getMonth() + 1) + "-" +
            pad(value.getDate()) + " " +
            pad(value.getHours()) + ":" +
            pad(value.getMinutes()) + ":" +
            pad(value.getSeconds()) + "." +
            pad(value.getMilliseconds(), 3)
        );
    }
    if (typeof value === "string") {
        return value.replace("T", " ").replace("Z", "");
    }
    return null;
};